export function deepCopy<T>(object: T, changedProperties?: Partial<T>): T {
    let copy = JSON.parse(JSON.stringify(object))
    if (changedProperties) {
        copy = Object.assign(copy, shallowCopy(changedProperties))
        copy = Object.assign(copy, deepCopy(changedProperties))
    }
    return copy
}

export function shallowCopy<T>(object: T, changedProperties?: Partial<T>): T {
    let copy = Object.assign({}, object)
    if (changedProperties) copy = Object.assign(copy, changedProperties)
    return copy
}

export default { deepCopy, shallowCopy }
